import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useIndicatorChart = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = chartData.indexes[0]?.indice_eficacia;

    return {
        value: series ? series : 0
    };
};

export default useIndicatorChart;
